// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { SearchContentsModel, SearchContentsParameter } from "@vanmeter/App/Services/SearchContentService";
import { Draft } from "immer";

export type SearchContentsState = {
    value?: SearchContentsModel;
    isLoading: boolean;
    parameter?: SearchContentsParameter;
};

const initialSearchContentsState: SearchContentsState = { value: undefined, isLoading: false };

const reducer = {
    "xSearchContents/StartLoading": (draft: Draft<SearchContentsState>, action: { parameter: SearchContentsParameter }) => {
        draft.isLoading = true;
        draft.parameter = action.parameter;
    },
    "xSearchContents/CompleteLoading": (
        draft: Draft<SearchContentsState>,
        action: { parameter: SearchContentsParameter; searchContents: SearchContentsModel },
    ) => {
        draft.value = action.searchContents;
        draft.isLoading = false;
    },
};

const xSearchContents = createTypedReducerWithImmer(initialSearchContentsState, reducer);

(reducers as any).xSearchContents = xSearchContents;

export type xSearchContentsState = {
    xSearchContents: SearchContentsState;
} & ApplicationState;

type xSearchContentsReducers = {
    [key: string]: typeof xSearchContents;
};

export type xSearchContentsActions = Parameters<xSearchContentsReducers[keyof xSearchContentsReducers]>[1] | AnyAction;
